import { Loader2 } from "lucide-react";

const Loader = () => (
  <div className="flex min-h-[50vh] items-center justify-center">
    <div className="flex flex-col items-center gap-4">
      <div className="relative">
        <div className="h-16 w-16 rounded-full border-4 border-muted border-t-primary animate-spin" />
        <Loader2 className="absolute inset-0 m-auto h-8 w-8 text-accent animate-spin-slow" />
      </div>
      <p className="text-muted-foreground text-sm font-display tracking-wider uppercase">Loading...</p>
    </div>
  </div>
);

export default Loader;
